export default __webpack_public_path__ + "static/media/SSL_certificate 1.32eacb16.png";